module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "homepage__wrapper"
  }, [_c('PortalHeader'), _vm._v(" "), _c('main', {
    staticClass: "m-main"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._t("default", function() {
    return [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "m-block m-block--big-height"
    }, [_c('p', {
      staticClass: "m-block__title"
    }, [_c('i', {
      staticClass: "m-block__icon fa fa-newspaper-o"
    }), _vm._v("\n                " + _vm._s(_vm.$t("content.news")) + "\n              ")]), _vm._v(" "), _c('news')], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "m-block m-block--big-height"
    }, [_c('p', {
      staticClass: "m-block__title"
    }, [_c('i', {
      staticClass: "m-block__icon fa fa-map"
    }), _vm._v("\n                " + _vm._s(_vm.$t("content.map")) + "\n              ")]), _vm._v(" "), _c('PortalMap')], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInOperationStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-rocket m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInOperationStage))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.revenues')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v("R$ " + _vm._s(Number(_vm.indicators.revenuesEstimate).toLocaleString('pt-BR')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.taxes')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v("R$ " + _vm._s(Number(_vm.indicators.taxesEstimate).toLocaleString('pt-BR')))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center"
    }, [_c('p', {
      staticClass: "m-info__text--small"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('portal.jobs')))])]), _vm._v(" "), _c('p', {
      staticClass: "m-info__text center-block"
    }, [_c('strong', [_vm._v(_vm._s(Number(_vm.indicators.jobsEstimate).toLocaleString('pt-BR')))])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('commons.companies')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-fighter-jet m-info__icon no-padding"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.companies))])])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInImplantationStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-cogs m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInImplantationStage))])])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-9"
    }, [_c('div', {
      staticClass: "m-block"
    }, [_c('div', {
      staticClass: "m-info"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 text-center m-info__title"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$t('content.parksInPlanningStage')))])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6 col-sm-3 m-info__group"
    }, [_c('span', {
      staticClass: "m-info__text--big center-block"
    }, [_c('i', {
      staticClass: "fa fa-3x font-white fa-calendar-check-o m-info__icon"
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.indicators.parksInPlanningStage))])])])])])])])])]
  })], 2)]), _vm._v(" "), _c('PortalFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56b7ee22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/Homepage.vue
// module id = 728
// module chunks = 1